import ReceiptIcon from "@mui/icons-material/Receipt";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import PaidIcon from "@mui/icons-material/Paid";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import GppGoodIcon from "@mui/icons-material/GppGood";
import CodeIcon from "@mui/icons-material/Code";

export const data = [
  {
    title: "Accept Payments",
    image: PaidIcon,
    description: [
      { text: "Credits cards", id: 1 },
      { text: "Mobile Money", id: 2 },
      { text: "Crypto", id: 3 },
    ],
  },
  {
    title: "Invoicing",
    image: ReceiptIcon,
    description: [
      { text: "Accept payments with invoices", id: 4 },
      { text: "Send recurring invoices", id: 5 },
      { text: "Attach files to documents", id: 6 },
    ],
  },
  {
    title: "Payment Links",
    image: InsertLinkIcon,
    description: [
      { text: "Accept payments online", id: 7 },
      { text: "Set up subscriptions", id: 8 },
      { text: "Collect Donations globally", id: 9 },
    ],
  },
  {
    title: "Settlements",
    image: AccountBalanceIcon,
    description: [
      { text: "All settlements within 48 hours", id: 11 },
      { text: "Payouts to any bank accounts", id: 12 },
      { text: "Payouts to mobile money wallets", id: 27 },
    ],
  },
  {
    title: "Pay Suppliers",
    image: ArrowOutwardIcon,
    description: [
      { text: "Automatic recurring payments", id: 14 },
      { text: "Cross border payments", id: 15 },
      { text: "Pay taxes", id: 16 },
    ],
  },
  {
    title: "QR code payments",
    image: QrCode2Icon,
    description: [
      { text: "Embeddable QR codes", id: 31 },
      { text: "Customizable QR codes", id: 32 },
      { text: "QR code stickers", id: 33 },
    ],
  },
  {
    title: "Full time support",
    image: SupportAgentIcon,
    description: [
      { text: "Fast support", id: 24 },
      { text: "Support over call , email, whatsapp", id: 25 },
      { text: "Live chat on the app", id: 26 },
    ],
  },
  {
    title: "Security",
    image: GppGoodIcon,
    description: [
      { text: "2 Factor Authentication", id: 28 },
      { text: "Sms and email notifications", id: 29 },
      { text: "OTP payment approvals", id: 30 },
    ],
  },
  {
    title: "Developer API",
    image: CodeIcon,
    description: [
      { text: "Access our developer API", id: 21 },
      { text: "Clear documentation", id: 22 },
      { text: "Support from our development team", id: 23 },
    ],
  },
];
